module.exports = __webpack_public_path__ + "static/media/validTeam.0f9aedcd.svg";